<template>
  <svg class="icon-spinner" width="30px"
       height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/spinner/blue</title>
    <g id="atoms/icons/30x30/spinner/blue" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M15,3 C21.627417,3 27,8.37541677 27,15.0063294 C27,21.637242 21.627417,27 15,27 C8.372583,27 9.98787936,24.6852437 9.98787936,24.6852437 C9.98787936,24.6852437 10.3903872,24.0878342 11.2390079,24.278063 C12.4005063,24.7517945 13.6699283,25.0116039 15,25.0116039 C20.5228475,25.0116039 25,20.5320899 25,15.0063294 C25,9.48056887 20.5228475,5.0010549 15,5.0010549 C9.4771525,5.0010549 5,9.48056887 5,15.0063294 C5,16.4686992 5.31356835,17.8577926 5.87710255,19.1099736 L5.83265354,19.0670498 C5.86106384,19.1069797 5.88763786,19.1460317 5.9124605,19.1842223 C5.98984544,19.3559295 6.07379973,19.5255349 6.16233319,19.6923355 C6.42121217,20.5092682 5.69687727,20.7500723 5.69687727,20.7500723 C4.15755104,21.5936368 3,18.059036 3,15.0063294 C3,8.37541677 8.372583,3 15,3 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
